export class Route {
  id: number;
  code: string;
  name: string;

  constructor(json: any) {
    try {
      this.id = json.id;
      this.code = json.code;
      this.name = json.name;
    } catch (ex) {
      this.id = 0;
      this.code = '';
      this.name = '';
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/route.ts